"use client";

import { lazy, Suspense } from "react";
import { useTenant } from "@/components/TenantProvider";

/* ═══ LAZY LOADED — setiap tenant chunk terpisah, error tidak menyebar ═══ */
const IpungNavbar = lazy(() => import("@/tenants/ipung/components/Navbar"));
const AdaraNavbar = lazy(() => import("@/tenants/adara/components/Navbar"));
const Smkn3Navbar = lazy(() => import("@/tenants/smkn3/components/Navbar").then(m => ({ default: m.Navbar })));
const VasalonNavbar = lazy(() => import("@/tenants/vasalon/components/Navbar"));
const KarpungNavbar = lazy(() => import("@/tenants/karpung/components/Navbar"));

function Fallback() { return <div className="h-16" />; }

export default function Navbar() {
  const { tenant } = useTenant();
  const bt = tenant.businessType;

  return (
    <Suspense fallback={<Fallback />}>
      {bt === "personal"     && <IpungNavbar />}
      {bt === "education"    && <Smkn3Navbar />}
      {bt === "salon"        && <VasalonNavbar />}
      {bt === "iot_agriculture" && <KarpungNavbar />}
      {!["personal","education","salon","iot_agriculture"].includes(bt) && <AdaraNavbar />}
    </Suspense>
  );
}
